export default __webpack_public_path__ + "static/media/discount-bro.487793f4.png";